import { actionGenerator, IReduxAction } from '../../utils/actions';

export const CHECK_SERVICE_AFTER_FILL_BALANCE = 'CHECKOUT_INFO :: CHECK_SERVICE_AFTER_FILL_BALANCE';

export type TCheckServiceAfterFillBalanceAction = IReduxAction<typeof CHECK_SERVICE_AFTER_FILL_BALANCE>;

export const checkServiceAfterFillBalance = actionGenerator<typeof CHECK_SERVICE_AFTER_FILL_BALANCE>(
  CHECK_SERVICE_AFTER_FILL_BALANCE,
);
